import { attr } from '@ember-data/model';
import { buildValidations } from 'ember-cp-validations';
import Fragment from 'ember-data-model-fragments/fragment';

export const maxReferenceIdLength = 50;

const Validations = buildValidations({});

export default class ChannelCustomFieldsCoveredSessions extends Fragment.extend(Validations) {
  @attr('string', { defaultValue: 'coveredSessions' }) name;
  @attr('string', { defaultValue: null }) value;
}
